import OwnerLayout from "../layout/OwnerLayout";
import { useState, useEffect } from "react";
import EditProfileModal from "../components/EditProfileModal";
import { API_BASE_URL } from "../../config/api";
import { authHeader } from "../../utils/authHeader";

const OwnerProfile = () => {
  const [open, setOpen] = useState(false);
  const [owner, setOwner] = useState(null);

  const fetchProfile = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/me`, {
        headers: {
          Authorization: authHeader().Authorization,
        },
      });

      const data = await res.json();

      if (res.ok) {
        setOwner(data);
      }
    } catch (err) {
      console.error("Failed to load profile");
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  if (!owner) return null;

  return (
    <OwnerLayout>
      <div className="dashboard-header">
        <p className="welcome-text">Profile!</p>
      </div>

      <div className="profile-card">
        <div className="profile-cover">
          <div className="profile-avatar">
            <img
              src={
                    owner.profilePhoto
                   ? owner.profilePhoto.startsWith("http")
                    ? owner.profilePhoto          // Cloudinary URL — use directly
                     : `${API_BASE_URL}${owner.profilePhoto}` // old local path
                     : "https://via.placeholder.com/80"
                  }
              alt="Owner"
            />
          </div>
        </div>

        <div className="profile-info">
          <h3>{owner.name || "Owner"}</h3>

          <p className="company-name-profile">
            {owner.companyName || ""}
          </p>

          {/* ✅ UPDATED LOCATION DISPLAY */}
          <p className="profile-location">
            {owner.district && owner.state
              ? `${owner.district}, ${owner.state}`
              : owner.city || ""}
          </p>

          <div className="profile-contact">
            <p>{owner.email}</p>
            <p className="profile-phone">{owner.phone}</p>
          </div>
        </div>

        <div className="edit-profile-wrapper">
          <button
            className="edit-profile-btn"
            onClick={() => setOpen(true)}
          >
            Edit Profile
          </button>
        </div>
      </div>

      <EditProfileModal
        open={open}
        onClose={() => setOpen(false)}
        owner={owner}
        refresh={fetchProfile}
      />
    </OwnerLayout>
  );
};

export default OwnerProfile;